// extracted by mini-css-extract-plugin
export var centerText = "_4m-8";
export var container = "_4m-0";
export var doughnutContainer = "_4m-7";
export var legend = "_4m-a";
export var legendItemColorDisplay = "_4m-b";
export var legendItemLabel = "_4m-d";
export var legendItemValue = "_4m-c";
export var lg = "_4m-5";
export var maxWidth = "_4m-9";
export var md = "_4m-4";
export var responsive = "_4m-6";
export var sm = "_4m-3";
export var xs = "_4m-2";
export var xxs = "_4m-1";